import React from 'react';
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";

const DobInputGroup = ({
    label,
    showBtnSave,
    dayName,
    monthName,
    yearName,
    values,
    isDisabled,
    onChange,
    onSave,
    dbInfo,
    allInputInfo
}) => {
    // Calculate age based on day, month, year
    const calculateAge = () => {
        // const day = values[dayName];
        // const month = values[monthName];
        const year = values[yearName];
        
        // if (!day || !month || !year) {
        //     return '';
        // }

        if (!year) {
                return '';
        }
        
        // const birthDate = new Date(year, month - 1, day);
        const today = new Date();
        
        let age = today.getFullYear() - year;
        // const monthDiff = today.getMonth() - birthDate.getMonth();
        
        // if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        //     age--;
        // }
        
        return age >= 0 ? age : '';
    };
    return (
        <>
        <div className='input-group mt-2'>
            <label className={'w-100'}>{label}</label>
            {dbInfo?.kqbt_paper_dob &&
                <div className={'col-sm-12'}>
            <span
                className={''}>KQBT: {dbInfo?.kqbt_paper_dob}</span>
                </div>
                }
            {showBtnSave &&
            <button type='button' className='btn btn-info btn-flat float-right ml-2'
                onClick={() => onSave()}>
                Save
            </button>
            }
            <div className={'row w-100'}>
                <div className={'col-sm-3 pr-0'}>
                    <input type='number'
                           placeholder={'Ngày'}
                           value={values[dayName] || ''}
                           name={dayName}
                           className='form-control'
                           min={1} max={31}
                           disabled={isDisabled}
                           onChange={onChange}
                    />
                    {dbInfo[`db_${dayName}`] &&
                    <div className={'col-sm-12'}>
                        <span className={''}>KQPM: {dbInfo[`db_${dayName}`]}</span>
                    </div>
                    }
                    <AllUserInputField arrInfo={allInputInfo}
                                       field={dayName}/>
                </div>
                <div className={'col-sm-3 pr-0'}>
                    <input placeholder={'Tháng'} type='number'
                           value={values[monthName] || ''}
                           className='form-control'
                           min={1} max={12}
                           disabled={isDisabled}
                           onChange={onChange}
                           name={monthName}
                    />
                    {dbInfo[`db_${monthName}`] &&
                    <div className={'col-sm-12'}>
                        <span className={''}>KQPM: {dbInfo[`db_${monthName}`]}</span>
                    </div>
                    }
                    <AllUserInputField arrInfo={allInputInfo}
                                       field={monthName}/>
                </div>
                <div className={'col-sm-3 pr-0'}>
                    <input type='number'
                           placeholder={'Năm'}
                           value={values[yearName] || ''}
                           className='form-control'
                           min={1900} max={new Date().getFullYear()}
                           disabled={isDisabled}
                           onChange={onChange}
                           name={yearName}
                    />
                    {dbInfo[`db_${yearName}`] &&
                    <div className={'col-sm-12'}>
                        <span className={''}>KQPM: {dbInfo[`db_${yearName}`]}</span>
                    </div>
                    }
                    <AllUserInputField arrInfo={allInputInfo}
                                       field={yearName}/>
                </div>
                <div className={'col-sm-3 pr-0'}>
                    <input type='number'
                           placeholder={'Tuổi'}
                           value={calculateAge()}
                           className='form-control'
                           readOnly
                           disabled
                    />
                </div>
            </div>
        </div>
        </>
    );
};

export default DobInputGroup;


